import { render, staticRenderFns } from "./userNotification.vue?vue&type=template&id=1532267a&"
import script from "./userNotification.vue?vue&type=script&lang=js&"
export * from "./userNotification.vue?vue&type=script&lang=js&"
import style0 from "./userNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports